import React from 'react';
import { AlertTriangle, CheckCircle, X } from 'lucide-react';
import styles from './NonVlStatusConfirmModal.module.css';

type Props = {
  summary: string;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

/** Confirm before applying a Non-VL (QA-only) status change. */
export function NonVlStatusConfirmModal({
  summary,
  loading = false,
  onCancel,
  onConfirm,
}: Props) {
  return (
    <div className={styles.overlay}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <div className={styles.iconWrap}>
              <CheckCircle color="#1d4ed8" size={18} />
            </div>
            <div className={styles.titleBlock}>
              <div className={styles.title}>Confirm Status Change</div>
              <div className={styles.subtitle}>
                {loading ? 'Please wait — updating ticket status…' : 'Non-VL status change'}
              </div>
            </div>
          </div>
          <button
            type="button"
            className={styles.closeBtn}
            disabled={loading}
            onClick={onCancel}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        {loading ? (
          <div className={styles.processing} role="status" aria-live="polite">
            <div className={styles.spinner} aria-hidden="true" />
            <div className={styles.processingText}>
              <b>Updating status…</b>
              <p className={styles.processingHint}>
                Do not close this window until it finishes.
              </p>
            </div>
          </div>
        ) : (
          <div className={styles.warning}>
            <AlertTriangle color="#1d4ed8" size={18} />
            <div>
              <b>Do you want to change the status?</b>
              <p>{summary}</p>
            </div>
          </div>
        )}

        <div className={styles.actions}>
          <button type="button" className={styles.cancelBtn} disabled={loading} onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className={styles.confirmBtn}
            disabled={loading}
            onClick={() => void onConfirm()}
          >
            {loading ? 'Updating…' : 'Yes, Change Status'}
          </button>
        </div>
      </div>
    </div>
  );
}
